<div class="delegation-cost-form">
  <div class="content-card">
    <h2 class="content-card__header">{{ 'DSS-DelegationCosts' | translate }}</h2>

    <form [formGroup]="formGroup">

      <div class="row">
        <div class="col-12 col-lg-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-InvoiceNumber' | translate }}</mat-label>
            <input matInput formControlName="invoiceNumber" maxlength="200"/>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-Description' | translate }}</mat-label>
            <input matInput formControlName="description" maxlength="250"/>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-Category' | translate }}</mat-label>
            <mat-select formControlName="delegationInvoiceTypeId">
              @for (invoiceTypes of listOfDelegationInvoiceTypes$ | async; track invoiceTypes) {
                <mat-option [value]="invoiceTypes.Id"> {{ invoiceTypes.Name }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-Currency' | translate }}</mat-label>
            <mat-select formControlName="currencyId">
              @for (currency of listOfCurrencies$ | async; track currency) {
                <mat-option [value]="currency.Id"> {{ currency.Name }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-6">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DCL-GrossValue' | translate }}</mat-label>
            <input matInput numericOnlyWtihTwoDecimals min="0" formControlName="grossValue" />
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <mat-form-field fxFill appearance="outline">
            <mat-label>{{ 'DCL-PaymentType' | translate }}</mat-label>
            <mat-select formControlName="paymentTypeId">
              @for (paymentType of listOfPaymentTypes$ | async; track paymentType) {
                <mat-option [value]="paymentType.Id">
                  {{ paymentType.Name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if (isEditMode) {
        <div class="upload">
          <fileUpload
            [maxFileCount]="maxFileCount"
            (onFilesChange)="onFilesChange($event)"
          ></fileUpload>
        </div>
      }

      @if (!!savedFiles) {
        <div>
          <div class="header-wrapper">
            <h3 class="content-card__header">{{ 'DSS-Attachments' | translate }}</h3>
          </div>
          <ul>
            @for (file of savedFiles; track file) {
              <li>
                <div class="file-row">
                  <p>{{ file.FileName }}</p>
                  <a (click)="downloadCostFile(file.Id, file.FileName)"><mat-icon>file_download</mat-icon></a>
                  <a (click)="viewCostFile(file.Id, file.FileName)"><mat-icon>find_in_page</mat-icon></a>
                </div>
              </li>
            }
          </ul>
        </div>
      }

      <div fxLayout="row" fxLayoutAlign="end space-between center">
        <button mat-raised-button color="accent" (click)="close()">{{ 'Close' | translate }}</button>
        @if (isEditMode) {
          <button mat-raised-button color="primary" (click)="saveCost()">{{ 'Save' | translate }}</button>
        }
      </div>
    </form>
  </div>
</div>